import {
  primaryColors,
  transparentColors
} from '@/assets/styles/helpers/colors.styles'

export const ratingStyles = {
  '&.MuiRating-root': {
    fontSize: '2rem'
  },
  '& .MuiRating-iconFilled': {
    color: primaryColors.white
  },
  '& .MuiRating-decimal': {
    outlineColor: primaryColors.white
  },
  '& .MuiRating-iconEmpty': {
    color: transparentColors.whiteShade3
  }
}
